import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'gatsby'

import LinkIcon from '../linkIcon'
import Image from '../image'

import trads from '../../intl/trads.json'

import transformLink from '../../utils/transformLink'

const PageCard = ({ctaLabel, url, title, mainImage, chapo, isSmall = false, directAccess = false, type = 'reg', mainTag = null }) => {
  const lang = useSelector(state => state.lang)

  return (
    <div className="w-full flex flex-col">
      <Link to={url} className={`card page-card ${type !== 'hub' ? 'page-card--reg' : ''}`}>
        { mainImage ?
          <Image
            image={mainImage}
            width="416"
            height="277"
            sizes={{"415": [367, 244], "767": [720, 478], "1023": [460, 305] }}
            classes="w-full card__img"
          />
          : <div className="card__empty card__empty--page">
              <img src="/img/logo.svg" alt="Terega Solutions" />
            </div>
        }
        <div className="page-card__content">
          <div className={ isSmall ? 'mb-5' : 'mb-8' }>
            { mainTag && mainTag !== 'Default' && mainTag !== 'Institutionnel' &&
              <p className="text-label mb-2 text-purple">{mainTag}</p>
            }
            <h3 className="card__title page-card__title">{title}</h3>
            <p className="page-card__chapo mt-4">{ chapo }</p>
          </div>
          <LinkIcon iconColor="purple" text={ ctaLabel } />
        </div>
      </Link>
      { directAccess &&
        <div className="page-card__direct">
          <p>{trads[lang].directAccess}</p>

          <ul className="list-reset mt-4">
            { directAccess.map((link, i) => {
              const url =  transformLink(link, false, false).url
              let title = (link.fields) ? link.fields.title : link.title

              return (
                <li key={i} className="mt-4">
                  <LinkIcon link={url} text={ title } className="link-underline" color="purple" small="true" />
                </li>
              )
            })}
          </ul>
        </div>
      }
    </div>
  )
}

export default PageCard